import { IResourceComponentsProps, useExport, useNavigation } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Input,
  Divider,
  useTable,
  Button,
  Form
} from '@pankod/refine-antd'

// import { useTable } from '@pankod/refine-core'

import { IMedium } from 'interfaces'
import { CreateMedium } from './create'
import { EditMedium } from './edit'
import { useState, useEffect } from 'react'
import Permissions from 'permissions'
import { useUserContext } from 'context/user'
const { PlusOutlined } = Icons

type Permission = {
  granted?: boolean
}

export const MediumList: React.FC<IResourceComponentsProps> = () => {
  const { userRole } = useUserContext()
  const { push } = useNavigation()
  const [pagination, setHasPagination] = useState<any>(true)
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})

  const { sorter, tableProps, setFilters, searchFormProps,tableQueryResult } = useTable<IMedium>({
    hasPagination: pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'created_at'],
    },
    onSearch: (values:any) => {
      return [
          {
              field: "name",
              operator: "contains",
              value:`%${values.title}%`,
          },
      ];
  },
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'mediums',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'mediums',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'created_at'],
    },
  })


 
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('mediums'))
      setCreatePermission(Permissions.can(userRole).createAny('mediums'))
      setEditPermission(Permissions.can(userRole).updateAny('mediums'))
      setDeletePermission(Permissions.can(userRole).deleteAny('mediums'))
    }
  }, [userRole])
  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
  }, [push, readPermission, userRole])
  return (
    <List
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton
            type="primary"
            style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}
            icon={<PlusOutlined />}
            onClick={() => show()}
          />,
        ],
      }}
    >
      {/* <Input.Search
        placeholder="Search By Name"
        onChange={e => {
          if (e.type === 'click') {
            setHasPagination(true)
          }
        }}
        allowClear
        style={{ width: '100%' }}
        onSearch={(value: any) => searchByName(value)}
      /> */}
       <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              searchFormProps.form?.submit()
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>
      <Divider />
      <Table {...tableProps}
       
      >
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<IMedium>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              {editPermission !== undefined && editPermission.granted ? (
                <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
              ) : null}
              {deletePermission !== undefined && deletePermission.granted ? (
                <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} />
              ) : null}
            </Space>
          )}
        />
      </Table>
      <CreateMedium modalProps={modalProps} formProps={formProps} />
      <EditMedium modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
